import { render, staticRenderFns } from "./PosSaleReport.vue?vue&type=template&id=229acf3d&scoped=true&"
import script from "./PosSaleReport.vue?vue&type=script&lang=js&"
export * from "./PosSaleReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "229acf3d",
  null
  
)

export default component.exports